module.exports = __webpack_public_path__ + "static/media/cityBikeActive.3984eaa6.png";